// export const getPaymentStatus = (article) => {
//   // If paymentStatus is false or no payments exist, it's Pending
//   if (
//     !article.paymentStatus ||
//     !article.payments ||
//     article.payments.length === 0
//   ) {
//     return {
//       status: "pending_payment",
//       label: "Pending Payment",
//       color: "warning",
//     };
//   }

//   // Check if all payments have UTR numbers
//   const allPaymentsHaveUTR = article.payments.every(
//     (payment) => payment.utrNo && payment.utrNo.trim() !== ""
//   );

//   if (allPaymentsHaveUTR) {
//     return {
//       status: "confirmed_payment",
//       label: "Confirmed Payment",
//       color: "success",
//     };
//   } else {
//     return {
//       status: "unconfirmed_payment",
//       label: "Unconfirmed Payment",
//       color: "info",
//     };
//   }
// };

// export const getPaymentStatus = (article) => {
//   const payments = article.payments || [];

//   // If paymentStatus is false
//   if (article.paymentStatus === false) {
//     if (
//       payments.length === 0 ||
//       payments.some((p) => !p.utrNo || p.utrNo.trim() === "")
//     ) {
//       return {
//         status: "unconfirmed_payment",
//         label: "Unconfirmed Payment",
//         color: "info", // initial payment but not confirmed
//       };
//     } else if (payments.every((p) => p.utrNo && p.utrNo.trim() !== "")) {
//       return {
//         status: "pending_payment",
//         label: "Pending Payment",
//         color: "warning", // partial payment confirmed, waiting for remaining
//       };
//     }
//   }

//   // If paymentStatus is true
//   if (article.paymentStatus === true) {
//     if (payments.length === 0 || payments.some((p) => !p.utrNo || p.utrNo.trim() === "")) {
//       // Some payments missing UTR → Unconfirmed
//       return {
//         status: "unconfirmed_payment",
//         label: "Unconfirmed Payment",
//         color: "info",
//       };
//     } else if (payments.every((p) => p.utrNo && p.utrNo.trim() !== "")) {
//       // All payments have UTR → Confirmed
//       return {
//         status: "confirmed_payment",
//         label: "Confirmed Payment",
//         color: "success",
//       };
//     }
//   }

//   // Fallback case
//   return {
//     status: "unknown_payment",
//     label: "Payment Status Unknown",
//     color: "secondary",
//   };
// };

export const getPaymentStatus = (article) => {
const normalizedRemaining = Math.abs(parseFloat(article.remaningFees) || 0) < 0.5 ? 0 : parseFloat(article.remaningFees);
const isPaid = normalizedRemaining === 0;
const payments = article.payments || [];

if (isPaid && payments.every(p => p.utrNo && p.utrNo.trim() !== "")) {
  return {
    status: "confirmed_payment",
    label: "Confirmed Payment",
    color: "success",
  };
} else if (payments.length === 0 || payments.some(p => !p.utrNo || p.utrNo.trim() === "")) {
  return {
    status: "unconfirmed_payment",
    label: "Unconfirmed Payment",
    color: "info",
  };
} else {
  return {
    status: "pending_payment",
    label: "Pending Payment",
    color: "warning",
  };
}
};

